import { observer } from 'mobx-react-lite'
import { Box, CardsFilter } from 'shared/ui'
import { useViewPageContext } from 'pages/surveys/pages/view/context/viewContext'

export const StatisticsBlocks = observer(() => {
  const { statisticsBlocks, activeFilter, setActiveFilter } = useViewPageContext()

  if (!statisticsBlocks.length) return null

  return (
    <Box padding={'0 20px'}>
      <CardsFilter
        items={statisticsBlocks}
        activeKey={activeFilter}
        onActiveFilter={(item) => {
          if (item.disabled) return

          setActiveFilter(item.key)
        }}
      />
    </Box>
  )
})
